import { ISectionLogger, ISectionLoggerFactory, LoggingSection } from "@multiweb/logging";
import { FormatProviderInputValues, FormatProviderParams } from "@multiweb/types/multiweb";
import { CaseInsensitiveMap } from "../DataTypes/CaseInsensitiveMap";
import { DIContainer } from "../DIContainer";

export interface IFactoryFormatProviderFunction {
    (value: FormatProviderInputValues,
        params: FormatProviderParams): string;
}

export class FormatProviderRegistrator {
    private _fncs = new CaseInsensitiveMap<IFactoryFormatProviderFunction>();

    private _logger: ISectionLogger;
    private static _instance: FormatProviderRegistrator;
    private static _getInstance(): FormatProviderRegistrator {
        if (!this._instance)
            this._instance = new FormatProviderRegistrator();

        return this._instance;
    }

    constructor() {
        this._logger = DIContainer.instance.create(ISectionLoggerFactory).create(LoggingSection.dataFormatRegistrator);
    }

    public static register(formatedProviderKey: string, fnc: IFactoryFormatProviderFunction): void {
        FormatProviderRegistrator._getInstance()._fncs.set(formatedProviderKey.toLowerCase(), fnc);
    }

    public static getFormatProvider(formatProviderKey: string, value: FormatProviderInputValues, params: FormatProviderParams): string {
        if (!formatProviderKey)
            return String(value);

        const factoryFncName = FormatProviderRegistrator._getInstance()._fncs.get(formatProviderKey.toLowerCase());
        if (factoryFncName) {
            return factoryFncName(value, params);
        } else {
            FormatProviderRegistrator._getInstance()._logger.warn("Definition for data format function %s was not found. Not formating.", formatProviderKey.toLowerCase());
            return String(value);
        }
    }
}
